import React, { useEffect, useRef, useState } from "react";

import Box from "../Box";
import { TableauEmbed } from "@stoddabr/react-tableau-embed-live";

type EmbedTableCardProps = {
  url: string;
  token: string;
  messageError?: string;
  isLoading: boolean;
  isUnavailable: boolean;
  openInformationModal: (title?: string) => void;
  device?: "phone" | "tablet" | "desktop";
};

const handleDevice = (width: number) => {
  if (width <= 768) {
    return "phone";
  }
  if (width < 1024) {
    return "tablet";
  } else {
    return "desktop";
  }
};

const EmbedTableCard = ({ url, token, device: propDevice, ...res }: EmbedTableCardProps) => {
  const vizRef = useRef<any>();
  const [device, setDevice] = useState<"phone" | "tablet" | "desktop">(
    handleDevice(window?.innerWidth)
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateWidth = (ev: Event) => {
    const target = ev.target as Window;

    if (vizRef && vizRef.current) {
      const viz = vizRef.current;
      setDevice(handleDevice(target.innerWidth));
      viz.setFrameSize(target.innerWidth, target.innerHeight);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [updateWidth]);
  return (
    <Box data-testid="presentation">
      <TableauEmbed
        sourceUrl={url}
        ref={vizRef}
        width={window?.innerWidth}
        height={window?.innerHeight}
        device={propDevice || device}
        token={token}
        {...{ "hide-tabs": true, toolbar: "hidden" }}
      />
    </Box>
  );
};

export default EmbedTableCard;
